import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result, SearcherRaw } from "../../../../interfaces";
import { Create } from "../../../searchers";
import { Adapter } from "../../../../shared/adapter";
import { SearchersAdapter } from "../../../../adapter/searchers-adapter";

export const FETCH_CREATE_SEARCHERS_REQUEST = 'FETCH_SEARCHERS_REQUEST';
export const FETCH_CREATE_SEARCHERS_SUCCESS = 'FETCH_SEARCHERS_SUCCESS';
export const FETCH_CREATE_SEARCHERS_FAILURE = 'FETCH_SEARCHERS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateSearchersRequest = () => {
    return {
        type: FETCH_CREATE_SEARCHERS_REQUEST,
    };
};

const fetchCreateSearchersSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_SEARCHERS_SUCCESS,
        payload: data
    };
};

const fetchCreateSearchersFailure = (error: any) => {
    return {
        type: FETCH_CREATE_SEARCHERS_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (searcher:SearcherRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateSearchersRequest());
        try {
            const response = await Create(searcher);
            dispatch(fetchCreateSearchersSuccess(
                Adapter.from(response.data).to((value) => new SearchersAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateSearchersFailure(error.message));
        }
    };
};